import React from 'react';
import { Button } from '../ui/button';
import { ArrowRight } from 'lucide-react';

const FinalCTASection = () => {
  return (
    <section data-testid="final-cta-section" className="relative min-h-[80vh] flex items-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://images.unsplash.com/photo-1676716184677-02c58a869b98?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODl8MHwxfHNlYXJjaHwyfHxlbGVnYW50JTIwd29tYW4lMjBmYXNoaW9uJTIwbW9kZWwlMjBzdHJlZXQlMjBzdHlsZSUyMGJlaWdlJTIwY29hdHxlbnwwfHx8fDE3NzM0MDA2NDB8MA&ixlib=rb-4.1.0&q=85"
          alt="Mujer elegante con estilo"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-[#111111]/90 via-[#111111]/70 to-[#111111]/50" />
      </div>

      {/* Content */}
      <div className="container-custom relative z-10">
        <div className="max-w-2xl">
          {/* Decorative line */}
          <div className="w-20 h-1 bg-[#C8A96A] mb-8" />

          {/* Headline */}
          <h2 
            data-testid="final-headline"
            className="font-serif text-4xl md:text-5xl lg:text-6xl font-bold text-white leading-tight mb-6"
          >
            Encuentra tu próximo<br />
            <span className="text-[#C8A96A]">look favorito</span>
          </h2>

          {/* Subheadline */}
          <p className="font-sans text-xl md:text-2xl text-white/80 mb-10 leading-relaxed">
            Moda femenina elegante de Trucco y Naelle con precios outlet.
          </p>

          {/* CTA */}
          <a 
            href="https://styleoutlet.es" 
            target="_blank" 
            rel="noopener noreferrer"
            data-testid="final-cta-button"
          >
            <Button className="bg-[#C8A96A] hover:bg-white hover:text-[#111111] text-white px-12 py-7 text-lg font-bold tracking-widest uppercase transition-all duration-300 cursor-pointer shadow-2xl">
              Entrar en StyleOutlet
              <ArrowRight className="ml-3 w-6 h-6" />
            </Button>
          </a>

          {/* Brand logos hint */}
          <div className="flex items-center gap-8 mt-12 pt-8 border-t border-white/20">
            <span className="font-serif text-2xl text-white/60 tracking-wider">TRUCCO</span>
            <span className="text-white/40">|</span>
            <span className="font-serif text-2xl text-white/60 tracking-wider">NAELLE</span>
          </div>
        </div>
      </div>

      {/* Decorative elements */}
      <div className="absolute bottom-0 right-0 w-1/3 h-1/2 bg-gradient-to-tl from-[#C8A96A]/20 to-transparent pointer-events-none" />
    </section>
  );
};

export default FinalCTASection;
